export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-US": {
        "a11y__accordion--expand": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["Click to expand ", _interpolate(_list(0))])},
        "a11y__accordion--collapse": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["Click to collapse ", _interpolate(_list(0)), " submenu"])}
      }
    }
  })
}
